import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { OpenReviewEntryModuleName } from '@/store/modules/modules'

export class OpenReviewEntryViewModel {
  private store = useStore()

  entryList: ComputedRef<ReviewEntry[]> = computed(() => this.store.getters[`${OpenReviewEntryModuleName}/entryList`])
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${OpenReviewEntryModuleName}/isLoading`])
  error: ComputedRef<Error | null> = computed(() => this.store.getters[`${OpenReviewEntryModuleName}/error`])

  async fetchReviewEntryList(userId: string, problemId: string): Promise<void> {
    await this.store.dispatch(`${OpenReviewEntryModuleName}/fetchReviewEntryList`, { userId, problemId })
  }
}
